// Module
var code = `<h2 class="section-header">Upload SSS pension file</h2>
  <form name="\$ctrl.uploadForm">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>GL debit code</td>
        <td>
          <selectize
            ng-required="true"
            options="\$ctrl.glAccounts"
            config="\$ctrl.selectConfig"
            ng-model="\$ctrl.input.accountCode">
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Create anniversary hold</td>
        <td>
          <select
            required
            ng-model="\$ctrl.input.createAnniversaryHold"
            boolean-options>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File format</td>
        <td>
          <selectize
            ng-required="true"
            options="\$ctrl.fileFormats"
            config="\$ctrl.selectFormatConfig"
            ng-model="\$ctrl.input.fileFormat"
          >
          </selectize>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>File</td>
        <td>
          <file-id-upload
            single-file="true"
            ng-required="true"
            ng-model="\$ctrl.input.fileId"
            max-files="1"
            name="fileUpload"
            show-file-name="true"
            show-remarks="false"
            enable-webcam="false"
            max-size="'10MB'">
          </file-id-upload>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="buttons">
      <button class="btn btn-success" ng-click="\$ctrl.submit()" ng-disabled="\$ctrl.uploadForm.\$invalid">Submit</button>
    </div>

  </form>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/batch/sss-pension/batch-sss-pension-upload.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;